import { getIsolationScope } from "@sentry/core";
/**
 * Sets a global tag so subsequent events carry it. It MUST target the isolation scope: every capture
 * in this package passes a per-app `Scope`, so a tag on the current scope would never be merged in.
 */
const setTag = (key, value) => {
    getIsolationScope().setTag(key, value);
};
export { setTag };
